import { trackPixelEvent } from '../components/MetaPixel'

// Single source of truth for the checkout destination. Every purchase CTA on
// the landing must import this — no hardcoded checkout URLs anywhere else.
export const CHECKOUT_URL = 'https://megapackenfermeria.impultienda.ar/checkout'

// Ignore repeat fires within this window so a double-tap / double-click on the
// same CTA cannot send two InitiateCheckout events.
const DEDUPE_MS = 2000

// Fire the Meta Pixel InitiateCheckout event without ever blocking navigation.
export function handleCheckoutClick(): void {
  try {
    const now = Date.now()
    const last = window.__mp_last_checkout_event ?? 0
    if (now - last < DEDUPE_MS) return
    window.__mp_last_checkout_event = now

    trackPixelEvent('InitiateCheckout', {
      content_name: 'Mega Pack Enfermería',
      content_ids: ['mega-pack-enfermeria'],
      content_type: 'product',
      value: 12.99,
      currency: 'USD',
    })
  } catch (_) {
    /* never block the redirect */
  }
}
